import React, { useState, useEffect } from 'react';
import ActivityContent from './ActivityContent';
import ActivitySidebar from './ActivitySidebar';
import { useParams } from 'react-router-dom';
import { t } from 'i18next';
import { i18n } from 'src/app/components/i18n/i18n';
import { Dashboard, DashboardContent } from '@/layouts/dashboard';

export function CreateActivity(props) {
  const { step } = props;
  const [currentStep, setCurrentStep] = useState(0);
  const { courseId, moduleId } = useParams();

  useEffect(() => {
    i18n.changeLanguage(process.env.REACT_APP_LOCALE);
  }, []);

  const steps = [
    {
      id: 0,
      route: 'nome',
      text: t('activity.stepsActivityName')
    },
    {
      id: 1,
      route: 'sobre',
      text: t('activity.stepsActivityAbout')
    },
    {
      id: 2,
      route: 'prazo',
      text: t('activity.stepsActivityDeadline')
    }
  ];

  function getStep() {
    switch (step) {
      case 'nome':
        setCurrentStep(0);
        break;
      case 'sobre':
        setCurrentStep(1);
        break;
      case 'prazo':
        setCurrentStep(2);
        break;
      default:
        setCurrentStep(0);
        break;
    }
  }

  useEffect(() => getStep());

  return (
    <Dashboard>
      <ActivitySidebar
        courseId={courseId}
        moduleId={moduleId}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        steps={steps}
      />

      <DashboardContent viewMode="create">
        <ActivityContent
          step={step}
          steps={steps}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
        />
      </DashboardContent>
    </Dashboard>
  );
}

export default CreateActivity;
